import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDefaultRoute, hasAdminAccess } from '../utils/roles';
import api from '../utils/api';

const BookmarkRedirect = () => {
    const { user } = useAuth();
    const [destination, setDestination] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkBookmark = async () => {
            if (!user) {
                setDestination('/login');
                setLoading(false);
                return;
            }

            try {
                // Check if user has admin access - redirect to admin panel
                if (hasAdminAccess(user)) {
                    setDestination('/admin');
                    return;
                }

                // For patient users, check bookmarks
                const response = await api.get('/users/me');
                const userData = response.data.user;
                const lastVisitedPath = userData?.lastVisited?.path;

                if (lastVisitedPath && lastVisitedPath.startsWith('/journal/')) {
                    setDestination(lastVisitedPath);
                } else {
                    setDestination('/dashboard');
                }
            } catch (error) {
                console.error('Failed to check bookmark:', error);
                // Use default route based on user role
                setDestination(getDefaultRoute(user));
            } finally {
                setLoading(false);
            }
        };

        if (user) {
            checkBookmark();
        }
    }, [user]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <div className="spinner"></div>
            </div>
        );
    }

    return <Navigate to={destination} replace />;
};

export default BookmarkRedirect;
